import React from 'react';
import {
    InputAdornment,
    Dialog,
    DialogContent,
    Button,
    FormControl,
    Card,
    CardContent,
    TextField,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import { withStyles } from '@material-ui/core/styles';
import CloseButton from '../close_button';

const StyledCard = withStyles(theme => ({
    root: {
        margin: 'auto',
        maxWidth: '500px',
        minWidth: "312px"
    }
}))(props => <Card elevation={0} className="card-box mb-4" {...props} />);

export default function OPTModal(props) {
    return (
        <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            open={props.open}
            maxWidth="lg"
            scroll={"paper"}
            onClose={props.onClose}>
            <DialogContent className="p-0">
                <CloseButton onClose={props.onClose} />
                <StyledCard>
                    <div className="card-header">
                        <div className="card-header--title py-2 font-size-lg 
                            font-weight-bold text-center">
                            Authentication required
                       </div>
                    </div>
                    <CardContent className="p-3">
                        <Alert severity="info">
                            For your security, we need to authenticate your request.
                            We've sent an OTP to the email {props.email}.
                            Please enter it below to complete verification.
                        </Alert>
                        <div className=" mt-3">
                            <FormControl className="w-100">
                                <TextField
                                    autoComplete="off"
                                    error={props.otpError ? true : false}
                                    helperText={props.otpError}
                                    fullWidth
                                    disabled={props.isProcessing}
                                    label="Email OTP"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MailOutlineTwoToneIcon />
                                            </InputAdornment>
                                        )
                                    }}

                                    value={props.otp}
                                    onChange={(e) => { props.setOTP(e.target.value.trim()) }}
                                />
                                <div className="text-right">
                                    <Button onClick={props.onOTPResend}
                                        className="font-size-lg p-0 pl-3" color="primary">
                                        Resend
                                    </Button>
                                </div>
                            </FormControl>
                        </div>
                        <div className="text-center">
                            <Button
                                color="primary"
                                variant="contained"
                                size="large"
                                className="my-2"
                                onClick={props.onOTPVerify}>
                                Continue
                                  </Button>
                        </div>
                    </CardContent>
                </StyledCard>
            </DialogContent>
        </Dialog>
    );
}